<ng-template #parameterTrailingMenuBar>
  <soft-menu-bar-button
    tooltip="Refresh"
    variant="outline"
    [iconOnly]="true"
    icon="fa-regular fa-arrows-rotate"
    (execute)="this.service.refreshEvents()"
  />
  <!--spacer-->
  <div class="h-full min-h-8 w-px select-none mx-1">&nbsp;</div>
  <soft-menu-bar-split-button
    label="Neuer Eintrag"
    tooltip="Neuer Eintrag"
    variant="primary"
    icon="fa-regular fa-plus"
    [responsive]="true"
    (execute)="this.service.handleContextMenuAction('createEmpty')"
  >
    <soft-menu *softMenuBarDropdownContent class="min-w-38">
      <soft-menu-item
        value="plan"
        label="Planeintrag"
        icon="fa-regular fa-database"
        (click)="this.service.handleContextMenuAction('createPlanEntry')"
      />
      <soft-menu-item
        value="appointment"
        label="Termin"
        icon="fa-regular fa-calendar"
        (click)="this.service.handleContextMenuAction('createAppointment')"
      />
    </soft-menu>
  </soft-menu-bar-split-button>
</ng-template>

<ng-template #viewLeadingMenuBar>
  <button
    type="button"
    (click)="hostComponent.minimize.set(!hostComponent.minimize())"
    class="hover:bg-hover px-1 cursor-pointer rounded-sm"
  >
    <soft-icon
      [name]="
        !hostComponent.minimize() ? 'fa-regular fa-sidebar' : 'fa-regular fa-sidebar'
      "
      class="text-base"
    />
  </button>
  <div class="h-full min-h-8 w-px select-none mx-1">&nbsp;</div>
  <soft-menu-bar-dropdown
    icon="fa-regular fa-calendar-range"
    [label]="viewTypeLabel()"
    [tooltip]="'Zeitraum:\n' + viewTypeLabel()"
    [responsive]="true"
    [hideChevron]="true"
  >
    <soft-menu *softMenuBarDropdownContent class="min-w-52">
      <div class="px-3 py-2 border-b text-sm font-semibold">Zeitraum</div>
      @for (opt of viewTypeOptions(); track opt.v) {
        <soft-menu-item
          [value]="opt.v"
          [label]="opt.l"
          [selected]="hostComponent.calendarViewType() === opt.v"
          (click)="hostComponent.calendarViewType.set(opt.v)"
        />
      }
    </soft-menu>
  </soft-menu-bar-dropdown>
  <div class="h-full min-h-8 w-px select-none mx-1">&nbsp;</div>
  <soft-menu-bar-picker
    [value]="hostComponent.calendarColumnWidth()"
    (valueChange)="hostComponent.calendarColumnWidth.set($event)"
    icon="fa-regular fa-arrows-left-right"
    label="Spaltenbreite"
    tooltip="Spaltenbreite"
    [responsive]="true"
    [wrap]="false"
  >
    <soft-picker-option value="small" title="Schmal" />
    <soft-picker-option value="large" title="Normal" />
    <soft-picker-option value="xxxlarge" title="Breit" />
  </soft-menu-bar-picker>
  <div class="h-full min-h-8 w-px select-none mx-1">&nbsp;</div>
  <soft-menu-bar-picker
    [value]="hostComponent.calendarDetails()"
    (valueChange)="hostComponent.calendarDetails.set($event)"
    icon="fa-regular fa-list"
    label="Details"
    tooltip="Details"
    [responsive]="true"
    [wrap]="false"
  >
    <soft-picker-option
      value="compact"
      title="Kompakt"
      icon="fa-regular fa-compress"
    />
    <soft-picker-option
      value="all"
      title="Alle"
      icon="fa-regular fa-table-list"
    />
  </soft-menu-bar-picker>
</ng-template>

<ng-template #selectionLeadingMenuBar>
  @if (selectedEvents().length === 1) {
    <soft-menu-bar-button
      variant="primary"
      icon="fa-regular fa-pencil"
      label="Editieren"
      tooltip="Editieren"
      [responsive]="true"
      (execute)="this.service.handleContextMenuAction('edit')"
    />
  }

  @if (isOrderSelection()) {
    <soft-menu-bar-button
      icon="fa-regular fa-message-sms"
      label="SMS senden"
      tooltip="SMS senden"
      [responsive]="true"
      (execute)="this.service.handleContextMenuAction('sms')"
    />
  }

  @if (isAppointment() || isTaskSelection()) {
    <div class="w-1 select-none" tabindex="-1">&nbsp;</div>
    <soft-menu-bar-button
      label="Duplizieren"
      tooltip="Duplizieren"
      icon="fa-regular fa-copy"
      [responsive]="true"
      (execute)="this.service.handleContextMenuAction('duplicate')"
    />

    <soft-menu-bar-button
      icon="fa-regular fa-copy"
      label="Kopieren"
      tooltip="Kopieren"
      [responsive]="true"
      (execute)="this.service.handleContextMenuAction('copy')"
    />
  }

  @if (selectedEvents().length > 0) {
    <soft-menu-bar-button
      icon="fa-regular fa-trash-alt"
      label="Löschen"
      tooltip="Löschen"
      variant="danger"
      [responsive]="true"
      (execute)="this.service.handleContextMenuAction('delete')"
    />
  }
</ng-template>

<ng-template #garageEventMenu>
  <soft-ds-context-menu>
    @if (selectedEvents().length === 1) {
      <soft-ds-context-menu-item
        icon="fa-regular fa-pen"
        label="Editieren"
        (triggered)="service.handleContextMenuAction('edit')"
      />
    }
    @if (isOrderSelection()) {
      <soft-ds-context-menu-item
        icon="fa-regular fa-message-sms"
        label="SMS senden"
        (triggered)="service.handleContextMenuAction('sms')"
      />
    }
    <soft-ds-context-menu-item
      icon="fa-regular fa-clone"
      label="Duplizieren"
      (triggered)="service.handleContextMenuAction('duplicate')"
    />
    <soft-ds-context-menu-item
      icon="fa-regular fa-copy"
      label="Kopieren"
      [keyboardShortcut]="[modifierKey, 'C']"
      (triggered)="service.handleContextMenuAction('copy')"
    />
    <soft-ds-context-menu-item
      icon="fa-regular fa-arrow-right"
      label="Auf nä. Montag kopieren"
      (triggered)="service.handleContextMenuAction('copyToNextMonday')"
    />
    <soft-ds-context-menu-divider />
    <soft-ds-context-menu-item
      icon="fa-regular fa-trash-can"
      label="Löschen"
      variant="danger"
      (triggered)="service.handleContextMenuAction('delete')"
    />
  </soft-ds-context-menu>
</ng-template>

<ng-template #selectionTrailingMenuBar>
  <span class="text-xs text-foreground/70 px-1">
    <span class="font-semibold">{{ selectedEvents().length }}</span>
    ausgewählt
  </span>
</ng-template>

